import { render, staticRenderFns } from "./RelatorioAtualizacoes.vue?vue&type=template&id=e4f6fbfa&"
import script from "./RelatorioAtualizacoes.vue?vue&type=script&lang=js&"
export * from "./RelatorioAtualizacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports